module.exports = __webpack_public_path__ + "img/gift_100.06e7aa80.webp";